<script>
import MessagePreview from 'dashboard/components/widgets/conversation/MessagePreview.vue';
import { MESSAGE_TYPE } from 'shared/constants/messages';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import { emitter } from 'shared/helpers/mitt';

export default {
  name: 'ReplyTo',
  components: {
    MessagePreview,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    messageType: {
      type: Number,
      required: true,
    },
    parentHasAttachments: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return { MESSAGE_TYPE };
  },
  methods: {
    scrollToMessage() {
      emitter.emit(BUS_EVENTS.SCROLL_TO_MESSAGE, {
        messageId: this.message.id,
      });
    },
  },
};
</script>

<template>
  <div
    class="px-2 py-1.5 rounded-md min-w-[10rem] mb-2 overflow-hidden"
    :class="{
      // Incoming bubble (gray): light card with accent left border
      'bg-white bg-opacity-80 dark:bg-slate-700/60 text-slate-800 dark:text-slate-100 border-l-4 border-hichat-400':
        messageType === MESSAGE_TYPE.INCOMING,
      // Outgoing bubble (blue): translucent white with white left border
      'bg-white/20 text-white border-l-4 border-white/70': messageType === MESSAGE_TYPE.OUTGOING,
      // When no parent attachments we can stretch horizontally a bit
      '-mx-1': !parentHasAttachments,
    }"
    @click="scrollToMessage"
  >
    <MessagePreview
      class="cursor-pointer"
      :message="message"
      :show-message-type="false"
      :default-empty-message="$t('CONVERSATION.REPLY_MESSAGE_NOT_FOUND')"
    />
  </div>
</template>
